import React from "react";

export default function SocialNetworkAccountCard({ socialNetworkAccount }) {
  let color = "";
  switch (socialNetworkAccount.socialNetwork.name) {
    case "Facebook":
      color = "bg-[#395592]";
      break;
    case "Instagram":
      color = "bg-[#C5006F]";
      break;
    case "Snapchat":
      color = "bg-[#F2EF00]";
      break;
    case "TikTok":
      color = "bg-[#000000]";
      break;
    case "Twitter":
      color = "bg-[#1C93E4]";
      break;
    case "LinkedIn":
      color = "bg-[#0961B8]";
      break;
    case "Youtube":
      color = "bg-[#F10000]";
      break;
    case "Twitch":
      color = "bg-[#8A42F2]";
      break;
    default:
      color = "bg-slate-700";
  }
  return (
    <div
      className={`w-52 h-24 ${color} flex flex-col justify-center items-center`}
    >
      <div className="text-xl font-bold">
        {socialNetworkAccount.socialNetwork.name}
      </div>
      <div>{socialNetworkAccount.userName}</div>
      <div>{socialNetworkAccount.nbFollowers} followers</div>
    </div>
  );
}
